
    <firmware-target-widget
      [entity]="entity"
      [options]="options"
      [layout]="layout"
    ></firmware-target-widget>
  